import React from 'react';
const SnsSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-sns" });
SnsSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-sns sirius-icon-sns-enhance" });
export default SnsSvg;
